<template>
  <div class="device-wrapper">
    <div class="device">
      <div class="screen">
        <slot></slot>
      </div>
      <div class="button">
        <!-- You can hook the "home button" to some JavaScript events or just remove it -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: function() {
    return {
      type: 'iphonex',
      scale: 17,
      width: null,
      height: null,
      skins: ['noShadow']
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  props: ['pagename']
}
</script>
<style lang="scss" scoped>
.device {
  padding: 19px 21px;
  position: relative;
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('/static/img/assets/portrait.png');

    background-size: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/IphoneScreen.vue